// extracted by mini-css-extract-plugin
module.exports = {"option":"styles_option___M5BA"};